module.exports = __webpack_public_path__ + "media/images/expert__nicolò-casolini-d794cc3755a63f8402212a776ab78678.png";